import React, {Component} from "react"
import {connect} from 'react-redux';
import Layout from "../../../components/Layout"
import "./index.scss"


import CustomTable from "../../../components/CustomTable";
import {columns, rows, headerInformation} from '../../../components/CustomTable/helpers/tableValuesReport'
import {columnsVar, rowsVar, headerInformationVar} from '../../../components/CustomTable/helpers/tableValuesReportVariance'

import {
    schedule_get_rows_table,
    schedule_set_valores_lote,
    schedule_get_rows_table_count,
    schedule_set_valores_unitario
} from "../../../store/actions/schedule";

import {
    Grid, Breadcrumb, BreadcrumbItem,Tab, Tabs
} from "carbon-components-react";

import leng from "../../../data";

import moment from "moment";


class Edit extends Component {

    async componentDidMount() {
        //await this.props.fetchData(0);
        //await this.props.countRows();
    }

    async onSubmitForm(type, data) {
        if (type == "Individual") {
            this.props.saveUnitario(data);
        } else {
            this.props.saveLote(data);
        }
    }

    async onChangePagination(skip) {
        await this.props.fetchData(skip);
    }

    render() {
        const onEditValues = (props) => alert(JSON.stringify(props));
        return (
            <Layout>
                <Grid class="painel" fullWidth>
                    <div className="container-fluid">
                        <div className="header-text header-text-report">
                            <h5>{leng.sideBar.intelligentJourney.title}</h5>
                            <h3>FP&A report</h3>
                            <Breadcrumb>
                                <BreadcrumbItem style={{color: "#000000"}} href="#">Filtering</BreadcrumbItem>
                                <BreadcrumbItem style={{color: "#000000"}} href="#">Report</BreadcrumbItem>
                            </Breadcrumb>
                        </div>
                        <div style={{paddingTop: "20px"}}>
                            <Tabs scrollIntoView={false}>
                                <Tab
                                    href="#"
                                    id="tab-1"
                                    label="Current"
                                >
                                    <div className="some-content" style={{paddingTop: "20px"}}>
                                        <CustomTable headerInformation={headerInformation} columns={columns}   editValues={onEditValues} rowsData={rows}/>
                                    </div>
                                </Tab>
                                <Tab
                                    href="#"
                                    id="tab-2"
                                    label="Variances"
                                >
                                    <div className="some-content" style={{paddingTop: "20px"}}>
                                        <CustomTable headerInformation={headerInformationVar} columns={columnsVar}  editValues={onEditValues} rowsData={rowsVar}/>
                                    </div>
                                </Tab>

                            </Tabs>
                        </div>

                    </div>
                </Grid>
            </Layout>
        )
    }
}

const mapStateToProps = ({schedule}) => schedule;

const mapDispatchToProps = dispatch => ({
    saveLote: (valor) => dispatch(schedule_set_valores_lote(valor)),
    saveUnitario: (valor) => dispatch(schedule_set_valores_unitario(valor)),
    fetchData: (skip) => dispatch(schedule_get_rows_table(skip)),
    countRows: () => dispatch(schedule_get_rows_table_count()),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Edit);
